import { Box, Flex, Text } from "@chakra-ui/react";
import moment from "moment";
import React from "react";
import { Feed, LiveMoment } from "../../data/api";
import FeedImage from "./components/FeedImage";
import FeedLink from "./components/FeedLink";
import Quote from "./components/Quote";
import Score from "./components/Score";

type Props = {
  feed: Feed;
};

const liveMomentTypeNames = {
  1: "Commentary",
  2: "Significant Moment",
  3: "GOAL",
  4: "Full Time",
  5: "Half Time",
  6: "Kick Off",
  7: "Quote",
  8: "Lancaster Quote",
  9: "York Quote",
  10: "Image",
  11: "Tweet",
  12: "Link",
  13: "1st Quarter",
  14: "3rd Quarter",
  15: "ROSES SCORE UPDATE",
};

const LiveFeed = ({ feed }: Props) => {
  return (
    <Flex direction="column" rounded={"lg"} overflow="hidden" color="white">
      <Box bg="gray.900" p={3}>
        <Text fontWeight="bold" textTransform="uppercase" fontSize="sm">
          {liveMomentTypeNames[feed.liveMomentTypeId]}
          {feed.team && feed.liveMomentTypeId !== LiveMoment.SCORE
            ? ` (${feed.team.sport.title})`
            : null}
        </Text>
      </Box>
      <Box bg="gray.700" p={3}>
        {[
          LiveMoment.COMMENTARY,
          LiveMoment.ANNOUNCEMENT,
          LiveMoment.GOAL,
          LiveMoment.FULL_TIME,
          LiveMoment.HALF_TIME,
          LiveMoment.KICK_OFF,
        ].includes(feed.liveMomentTypeId) ? (
          feed.text
        ) : [
            LiveMoment.QUOTE,
            LiveMoment.LANCS_QUOTE,
            LiveMoment.YORK_QUOTE,
          ].includes(feed.liveMomentTypeId) ? (
          <Quote text={feed.text} author={feed.author} />
        ) : LiveMoment.IMAGE === feed.liveMomentTypeId ? (
          <FeedImage src={feed.pictureFile} author={feed.author} />
        ) : LiveMoment.TWEET === feed.liveMomentTypeId ? (
          <Box p={3}>
            <Text>"{feed.text}"</Text>
            <Text mt={2} fontSize="sm">
              @{feed.author}
            </Text>
          </Box>
        ) : LiveMoment.LINK === feed.liveMomentTypeId ? (
          <Box p={3}>
            <FeedLink link={feed.text} />
            <Text mt={2} fontSize="sm">
              - {feed.author}
            </Text>
          </Box>
        ) : [LiveMoment.FIRST_QUARTER, LiveMoment.THIRD_QUARTER].includes(
            feed.liveMomentTypeId,
          ) ? (
          <Score
            lancaster={feed.scoreGameLancs}
            york={feed.scoreGameYork}
            type="Game"
          />
        ) : LiveMoment.SCORE === feed.liveMomentTypeId ? (
          <Score
            lancaster={feed.scoreRosesLancs}
            york={feed.scoreRosesYork}
            type="Roses"
          />
        ) : null}
      </Box>
      <Flex bg="gray.900" p={3} fontSize="sm" justifyContent="space-between">
        <Text opacity={0.6}>
          {feed.team ? `${feed.team.title} - ${feed.team.sport.title}` : ""}
        </Text>
        <Text opacity={0.6}>{moment(feed.updatedAt).format("LLL")}</Text>
      </Flex>
    </Flex>
  );
};

export default LiveFeed;
